export default __webpack_public_path__ + "static/media/Home-icon.5d857f27.svg";